export default [

    {
        path: '/404-not-found',
        name: 'erro-404-not-found',
        component: () => import('@/aplicacao/_erros/404-NotFound'),
        meta: { autenticacao: true },
    },

    {
        path: '/403-forbidden',
        name: 'erro-403-forbidden',
        component: () => import('@/aplicacao/_erros/403-Forbidden'),
        meta: { autenticacao: true },
    },

]
